import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectPageId = createSelector(
  (state: RootState) => state.layout.pageId,
  (pageId: string) => pageId
)

export default selectPageId
